<template>
    <div class="story-categories"> 
        <Collapse>
            <Panel name="1" class="cope-panel">
                <div class="inner-tree">
                    <Avatar style="color:#1E89A7;" class="avatar" shape="square" :src="copeImg"/>
                    <p style="color:#1E89A7;padding-left:65px;font-size:18px;line-height:18px;position:absolute;top:15px">
                        <b>Cope</b><br/>
                        <span style="font-size:12px">Build resilience against the pressures of life.</span>
                    </p>
                </div>
                <div slot="content">
                    <div class="tracks-list">
                        <div class="track-item" v-for="(item,i) in groupedItems['Cope']" :key="i" @click="redirect(item)">
                            <p style="color:#1E89A7;padding:3px 0">
                                {{item.title}}</p>
                        </div>
                    </div>
                </div>
            </Panel>
            <Panel name="2" class="thrive-panel">
                <div class="inner-tree">
                    <Avatar style="color:#F19B2F;" class="avatar" shape="square" :src="thriveImg"/>
                    <p style="color:#F19B2F;padding-left:65px;font-size:18px;line-height:18px;position:absolute;top:15px">
                        <b>Thrive</b><br/>
                        <span style="font-size:12px">Infuse your mind with mindfulness exercises.</span>
                    </p>
                </div>
                <div slot="content">
                    <div class="tracks-list">
                        <div class="track-item" v-for="(item,i) in groupedItems['Thrive']" :key="i" @click="redirect(item)">
                            <p style="color:#F19B2F;padding:3px 0">
                                {{item.title}}</p>
                        </div>
                    </div>
                </div>
            </Panel>
            <Panel name="3" class="nourish-panel">
                <div class="inner-tree">
                    <Avatar style="color:#83CA27;" class="avatar" shape="square" :src="nourishImg"/>
                    <p style="color:#83CA27;padding-left:65px;font-size:18px;line-height:18px;position:absolute;top:15px">
                        <b>Nourish</b><br/>
                        <span style="font-size:12px">Nourish your body from the inside out.</span>
                    </p>
                </div>
                <div slot="content">
                    <div class="tracks-list">
                        <div class="track-item" v-for="(item,i) in groupedItems['Nourish']" :key="i" @click="redirect(item)">
                            <p style="color:#83CA27;padding:3px 0">
                                {{item.title}}</p>
                        </div>
                    </div>
                </div>
            </Panel>
            <Panel name="4" class="heal-panel">
                <div class="inner-tree">
                    <Avatar style="color:#4E1C9B;" class="avatar" shape="square" :src="healImg"/>
                    <p style="color:#4E1C9B;padding-left:65px;font-size:18px;line-height:18px;position:absolute;top:15px">
                        <b>Heal</b><br/>
                        <span style="font-size:12px">Facts and myths about mental illness.</span>
                    </p>
                </div>
                <div slot="content">
                    <div class="tracks-list">
                        <div class="track-item" v-for="(item,i) in groupedItems['Heal']" :key="i" @click="redirect(item)">
                            <p style="color:#4E1C9B;padding:3px 0">
                                {{item.title}}</p>
                        </div>
                    </div>
                </div>
            </Panel>
        </Collapse>
    </div>
</template>

<script>
import _ from 'lodash';
import copeImg from '@/assets/svg/cope.svg'
import thriveImg from '@/assets/svg/thrive.svg'
import nourishImg from '@/assets/svg/nourish.svg'
import healImg from '@/assets/svg/heal.svg'

export default {
    props: {
        planId: {
            type: String,
            required: true
        }
    },
    computed: {
        groupedItems() {
            if (!this.planInfo) return []
            return _.groupBy( this.planInfo.pages, 'data.category');
        } 
    },
    data(){
        return {
            copeImg,
            thriveImg,
            nourishImg,
            healImg,
            planInfo: {},
            loadingPlan: false
        }
    },
    mounted() {
        this.loadingPlan = true
        this.$store.dispatch('library/getPlanInfo', this.planId)
            .then(res => {
                this.planInfo = res
                this.loadingPlan = false
            },
            error => {
                this.loadingPlan = false
            })
    },
    methods: {
        redirect(item){
            if( !item ) return;
            
            let params = item.data.modules.join()
            this.$store.commit('setPageTitle', item.title);
            this.$router.push('/track/'+item.id+'?careplan_ids=' + params);
        }
    }
}
</script>

<style scoped>
    .ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {
        height: 70px;
        line-height: 50px;
        margin-left: 20px;
    }
    .avatar > img {
        width: 45px !important;
        height: 45px !important;
    }
    
    .inner-tree {
        display:inline-block;
    }

    .avatar {
        font-size: 52px;
        line-height: 50px;
        position: absolute;
        left: 15px;
        top: 12px;
        width: 45px;
        height: 45px;
        background: transparent;
    }
    .track-item {
        padding:10px 0 10px 70px;
        border-top:.05em solid #f2f2f2;
    }
</style>
